export type NavigationMatchStrategy = 'exact' | 'prefix';

export interface NavigationDestination {
  to: string;
  activePaths?: readonly string[];
  match?: NavigationMatchStrategy;
}

function matchesPath(pathname: string, target: string, strategy: NavigationMatchStrategy): boolean {
  if (strategy === 'exact') return pathname === target;
  return pathname === target || pathname.startsWith(`${target}/`);
}

/**
 * Resolve one active destination. Longest match wins, so a parent such as
 * Settings never appears selected beside Role Management or Billing.
 */
export function resolveActiveNavigationHref(
  items: readonly NavigationDestination[],
  pathname: string,
): string | null {
  let winner: { href: string; score: number } | null = null;

  for (const item of items) {
    const candidates = [item.to, ...(item.activePaths ?? [])];
    for (const candidate of candidates) {
      const strategy = candidate === item.to ? (item.match ?? 'prefix') : 'prefix';
      if (!matchesPath(pathname, candidate, strategy)) continue;
      if (!winner || candidate.length > winner.score) {
        winner = { href: item.to, score: candidate.length };
      }
    }
  }

  return winner?.href ?? null;
}
